import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "history-list" }
const _hoisted_2 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "row-left" }
const _hoisted_5 = { class: "tier mono" }
const _hoisted_6 = { class: "row-right" }
const _hoisted_7 = { class: "time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.games.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "empty-icon" }, "♠", -1),
          _createElementVNode("div", { class: "empty-text" }, "No games yet", -1),
          _createElementVNode("div", { class: "empty-sub" }, "Go flip some coins!", -1)
        ]))]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (game) => {
            return (_openBlock(), _createElementBlock("div", {
              key: game.id,
              class: "history-row"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", _ctx.badgeClass(game)])
                }, _toDisplayString(_ctx.badgeText(game)), 3),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.formatSats(game.tier)), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", {
                  class: _normalizeClass(["payout mono", _ctx.payoutClass(game)])
                }, _toDisplayString(_ctx.payoutText(game)), 3),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.timeAgo(game.createdAt)), 1)
              ])
            ]))
          }), 128))
        ]))
  ]))
}